$(document).ready(function(){
   var width = $(window).width();
 
  $('.announcementbar_cols').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
  $('.filterToggle').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
      $('body').addClass('filterOpen');
      $('.fullPage').addClass('witmenu');
    }, 50);
  });

  $('.off-canvas--overlay, .template-collection .collection_cols .off-canvas--close').on('click', function(e){
    e.preventDefault();
    $('.fullPage').removeClass('witmenu');
    $('body').removeClass('filterOpen');
  });

  $('.product_description_tabs .desc_tab').on('click',function(e){
    e.preventDefault();
    if($(this).hasClass('active')){
      
//       $(this).removeClass('active');
//       $('.dcont').removeClass('active');
//       $('.desc_tab img').css('transform','rotate(0)');
//       if (width < 768){
//         $('.dcont').slideUp('slow');
//       }
      return false;
    }
    var id = $(this).data('id');
    $('.desc_tab').removeClass('active');
    $('.desc_tab img').css('transform','rotate(0)');
    $(this).addClass('active');
    $(this).find('img').css('transform','rotate(180deg)');
    $('.dcont').removeClass('active');
    if (width < 768){
      $('.dcont').slideUp('fast');
    }
    if (width < 768){
      $('.'+ id).slideDown('slow');
      $('.'+ id).addClass('active');
    }else{
      $('.'+ id).addClass('active');
    }
  });
  
});

window.onload = function() {
    jQuery(function($) {
      var offset = 300;
      var duration = 500;
      $(window).scroll(function() {
        if ($(this).scrollTop() > offset) {
          $('#myBtn').fadeIn(duration);
        } 
        else {
          $('#myBtn').fadeOut(duration);
        }
      });
      $('#myBtn').unbind('click.smoothscroll').bind('click', function(e) {
        e.preventDefault();
        $('html, body').animate( { scrollTop: 0 }, duration);
        return false;
      })
    });
  }